import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitosolapurcab() {



const cardData = {
  keyword: " Mumbai to Solapur Cab",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai to Solapur cab services for travelers planning a smooth journey between Maharashtra’s major cities. Solapur is known for its rich cultural heritage, religious temples, and textile industry, attracting tourists, pilgrims, and business travelers throughout the year. Whether you are planning a family trip, a pilgrimage tour, a business visit, or a weekend getaway, our cab service ensures a safe and comfortable travel experience with experienced drivers and well-maintained vehicles. The road distance from Mumbai to Solapur is approximately 450 km and the journey offers scenic highway views through Maharashtra’s countryside. We provide flexible booking options including one-way cab service, round-trip packages, and multi-day travel plans with transparent per-kilometer pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With punctual pickups from anywhere in Mumbai, professional chauffeurs skilled in long-distance driving, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Solapur cab booking.",

topPlaces: [
  {
    title: "Siddheshwar Temple",
    description:
      "Siddheshwar Temple is the most famous religious site in Solapur and is dedicated to Lord Siddheshwar, a revered saint believed to be an incarnation of Lord Shiva. The temple is located on a small island in the middle of Siddheshwar Lake, creating a peaceful and spiritual environment for devotees. Pilgrims visit throughout the year to offer prayers and participate in religious ceremonies, especially during the grand Siddheshwar Yatra festival held annually. Visitors can walk around the temple complex, enjoy the scenic lake views, and experience the spiritual atmosphere. Traveling by cab from Mumbai allows devotees to comfortably reach Solapur and spend ample time exploring the temple and nearby attractions."
  },
  {
    title: "Siddheshwar Lake",
    description:
      "Siddheshwar Lake is a scenic water body located in the heart of Solapur and surrounds the famous Siddheshwar Temple. The lake adds to the beauty and serenity of the temple complex and is a popular place for peaceful walks, photography, and relaxation. Visitors can enjoy the calm atmosphere while admiring the reflections of the temple structures in the water. The surrounding area also includes gardens and pathways that make it a pleasant place for tourists and locals alike. A cab journey from Mumbai ensures convenient travel so visitors can explore the lake and temple area comfortably."
  },
  {
    title: "Solapur Bhuikot Fort",
    description:
      "Solapur Bhuikot Fort is a historic fort located near Siddheshwar Temple and is one of the important heritage landmarks in the city. The fort was built during the Bahmani Sultanate period and later controlled by various dynasties including the Adil Shahi rulers. The structure features massive walls, strong bastions, and ancient gateways that reflect medieval military architecture. Visitors interested in history and architecture enjoy exploring the fort and learning about its historical significance. Traveling by cab allows tourists to easily include this historic monument in their Solapur sightseeing itinerary."
  },
  {
    title: "Great Indian Bustard Sanctuary (Nannaj)",
    description:
      "The Great Indian Bustard Sanctuary at Nannaj near Solapur is an important wildlife conservation area dedicated to protecting the endangered Great Indian Bustard bird species. The sanctuary is home to various birds, wildlife species, and grassland ecosystems that make it a fascinating destination for bird watchers and nature lovers. Visitors often explore the sanctuary to observe rare birds and enjoy the natural landscape of the Deccan plateau. A comfortable cab trip from Mumbai allows travelers to include this unique wildlife destination in their Solapur tour."
  },
  {
    title: "Akkalkot Swami Samarth Maharaj Temple",
    description:
      "Akkalkot Swami Samarth Temple, located near Solapur, is one of the most important pilgrimage sites in Maharashtra. The temple is dedicated to Swami Samarth Maharaj, a revered spiritual saint believed to be an incarnation of Lord Dattatreya. Thousands of devotees visit the temple every year to seek blessings and experience the peaceful spiritual atmosphere. The temple complex includes prayer halls, meditation spaces, and religious activities that attract pilgrims from across India. Booking a cab from Mumbai allows devotees to comfortably visit Akkalkot along with Solapur’s other sacred sites."
  },
  {
    title: "Pandharpur Vitthal Temple",
    description:
      "Pandharpur, located not far from Solapur, is home to the famous Vitthal Rukmini Temple dedicated to Lord Vitthal, a form of Lord Krishna. The temple is one of the most important pilgrimage destinations in Maharashtra and is visited by millions of devotees during the annual Ashadhi and Kartiki Ekadashi festivals. Pilgrims often travel to Pandharpur to participate in spiritual rituals and experience the devotional atmosphere of the temple town. Traveling by cab from Mumbai to Solapur allows visitors to easily include Pandharpur in their religious tour."
  },
  {
    title: "Solapur Science Centre",
    description:
      "Solapur Science Centre is an educational attraction designed to promote scientific learning and curiosity among visitors of all ages. The center features interactive exhibits, science demonstrations, and educational displays that explain various scientific principles in an engaging way. Students and families often visit the center to explore the fascinating world of science while enjoying hands-on activities and experiments. A cab service allows travelers to conveniently reach the science center and explore it during their visit to Solapur."
  },
  {
    title: "Hipparga Lake",
    description:
      "Hipparga Lake is a scenic reservoir located on the outskirts of Solapur and is a peaceful destination for nature lovers and photographers. The lake is surrounded by greenery and open landscapes, creating a calm environment ideal for relaxation and bird watching. Visitors often enjoy quiet walks along the water’s edge and beautiful sunrise or sunset views over the lake. A comfortable cab journey from Mumbai allows travelers to explore this natural attraction while visiting Solapur."
  },
  {
    title: "Solapur Textile Market",
    description:
      "Solapur is widely known for its textile industry, especially the famous Solapur chaddars and handloom products. The Solapur Textile Market is a vibrant shopping destination where visitors can explore a wide variety of locally produced blankets, towels, and cotton fabrics. Travelers often purchase these products as souvenirs or gifts while visiting the city. Traveling by cab makes it easy for tourists to explore the market and experience the commercial culture of Solapur."
  },
  {
    title: "Kambar Talav",
    description:
      "Kambar Talav is a popular lake and recreational area in Solapur where locals and tourists come to relax and enjoy outdoor activities. The area around the lake includes walking paths, gardens, and open spaces suitable for family outings and evening walks. Visitors can enjoy the peaceful surroundings, take photographs, and spend time in nature away from the busy city areas. A cab trip from Mumbai allows travelers to explore this pleasant local attraction while visiting Solapur."
  }
],



services: [
{
name: "Mumbai to Solapur Cab",
description: "Mumbai to Solapur cab service offers reliable long-distance transportation for travelers heading from Mumbai to the historic city of Solapur in Maharashtra. The route is commonly used for business travel, family visits, and religious tourism, including trips to Pandharpur and Akkalkot nearby. Our vehicles are well maintained and suitable for highway travel with comfortable seating and ample luggage space. Professional drivers ensure safe driving and punctual pickup services from homes, hotels, offices, railway stations, and airport terminals across Mumbai. Air-conditioned vehicles ensure relaxed travel throughout the journey. Ideal for family trips, corporate travel, and pilgrimage tours. Flexible booking options allow convenient travel planning."
},
{
name: "Mumbai to Solapur Taxi",
description: "Mumbai to Solapur taxi service provides comfortable and dependable transportation for passengers traveling between the two major cities of Maharashtra. The journey covers national highways and ensures smooth long-distance travel with experienced drivers. Vehicles provide spacious seating and smooth ride quality suitable for extended highway journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for tourism visits, family trips, and corporate journeys. Air-conditioned vehicles ensure comfortable travel experiences."
},
{
name: "Mumbai to Solapur Cab Service",
description: "Mumbai to Solapur cab service offers dependable interstate transportation for passengers planning long-distance travel across Maharashtra. Vehicles used for this route provide comfortable seating and reliable highway performance for extended journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for family visits, business trips, and tourism travel. Spacious vehicles ensure relaxed journeys for passengers traveling together. Flexible booking options allow convenient ride scheduling."
},
{
name: "Mumbai to Solapur Taxi Service",
description: "Mumbai to Solapur taxi service provides convenient intercity transportation for travelers visiting Solapur for business, tourism, or family purposes. Vehicles are suitable for highway travel and provide smooth driving performance with spacious seating. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for corporate travel, tourism journeys, and family visits. Air-conditioned vehicles ensure comfortable journeys throughout the trip."
},
{
name: "Cab from Mumbai to Solapur",
description: "Cab from Mumbai to Solapur offers reliable transportation for travelers planning long-distance journeys across Maharashtra. Vehicles provide comfortable seating and smooth ride quality suitable for highway travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for family trips, corporate journeys, and tourism visits. Comfortable vehicles ensure relaxed travel experiences throughout the journey. Flexible booking options allow convenient ride reservations."
},
{
name: "Taxi from Mumbai to Solapur",
description: "Taxi from Mumbai to Solapur provides convenient travel solutions for passengers visiting Solapur city and nearby pilgrimage destinations. Vehicles are designed for long-distance highway journeys and offer comfortable seating for extended travel. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism travel, family visits, and business trips. Air-conditioned vehicles ensure comfortable journeys throughout the route."
},
{
name: "Mumbai to Solapur Cab Booking",
description: "Mumbai to Solapur cab booking allows travelers to easily reserve vehicles for long-distance intercity travel. Online and phone booking options provide instant confirmation and convenient ride scheduling. Vehicles used for highway travel offer comfortable seating and smooth performance throughout the journey. Professional drivers ensure punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for corporate travel, family trips, and tourism visits."
},
{
name: "Mumbai to Solapur Taxi Booking Online",
description: "Mumbai to Solapur taxi booking online provides convenient digital reservations for passengers planning intercity travel. Travelers can easily schedule pickups and receive instant confirmation for their journey. Vehicles provide comfortable seating and smooth ride quality suitable for highway travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for families, tourists, and business travelers."
},
{
name: "Mumbai to Solapur Cab Price",
description: "Mumbai to Solapur cab price options provide transparent fare estimates for passengers planning intercity journeys. Pricing depends on vehicle category, travel distance, and trip duration. Travelers can choose sedans, SUVs, or MPV vehicles depending on comfort needs and group size. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Transparent pricing ensures easy budgeting for travelers."
},
{
name: "Mumbai to Solapur Taxi Fare",
description: "Mumbai to Solapur taxi fare services offer flexible pricing options depending on vehicle type and travel duration. Travelers can choose economical sedans or spacious SUVs depending on comfort requirements. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for tourism travel, business trips, and family visits. Comfortable vehicles ensure relaxed journeys."
},
{
name: "Mumbai to Solapur One Way Cab",
description: "Mumbai to Solapur one way cab service provides economical intercity transportation without return charges. Vehicles provide comfortable seating and smooth highway performance suitable for long-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for passengers traveling one way for business trips, relocation, or family visits. Air-conditioned vehicles ensure comfortable travel experiences."
},
{
name: "Mumbai to Solapur Round Trip Taxi",
description: "Mumbai to Solapur round trip taxi service provides convenient transportation for travelers planning return journeys between the two cities. Vehicles are suitable for long-distance highway travel and multi-day trips. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for family visits, tourism journeys, and corporate travel."
},
{
name: "Mumbai to Solapur Innova Cab",
description: "Mumbai to Solapur Innova cab service provides spacious MPV transportation ideal for families and group travelers. The Toyota Innova offers comfortable seating, smooth highway performance, and ample luggage space for long-distance journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for family travel, pilgrimage tours, and corporate journeys."
},
{
name: "Mumbai to Solapur Ertiga Cab",
description: "Mumbai to Solapur Ertiga cab service offers comfortable MPV transportation suitable for small families and groups traveling long distances. The Maruti Ertiga provides spacious seating and smooth ride quality for interstate highway travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism visits, family travel, and business trips."
},
{
name: "Mumbai to Solapur Sedan Cab",
description: "Mumbai to Solapur sedan cab service provides economical and comfortable transportation for long-distance travel between the two cities. Sedan vehicles offer smooth ride performance and comfortable seating for small families or corporate travelers. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Air-conditioned sedans ensure comfortable travel experiences for passengers."
}
],

tableData: [
["Mumbai to Solapur Cab","Mumbai to Solapur Taxi"],
["Mumbai to Solapur Cab Service","Mumbai to Solapur Taxi Service"],
["Cab from Mumbai to Solapur","Taxi from Mumbai to Solapur"],
["Mumbai to Solapur Cab Booking","Mumbai to Solapur Taxi Booking Online"],
["Mumbai to Solapur Cab Price","Mumbai to Solapur Taxi Fare"],
["Mumbai to Solapur One Way Cab","Mumbai to Solapur Round Trip Taxi"],
["Mumbai to Solapur Innova Cab","Mumbai to Solapur Ertiga Cab"],
["Mumbai to Solapur Sedan Cab","Solapur Taxi from Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance highway travel from Mumbai to Solapur. They are familiar with major routes, toll highways, and traffic patterns, ensuring a smooth and safe journey for passengers."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Omshree Cabs offers transparent pricing for Mumbai to Solapur cab bookings. Customers receive clear details about per-kilometer charges, toll fees, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Service",
    WhyChoosedescription: "Our Mumbai to Solapur cab service operates 24 hours a day. Whether you want to start early morning or travel overnight, we provide reliable cab booking anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, regularly cleaned, and fully air-conditioned to ensure passengers enjoy a comfortable long-distance journey."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Options",
    WhyChoosedescription: "We offer flexible travel options including one-way cab bookings, round trips, and multi-day travel packages from Mumbai to Solapur."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs provides a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, luxury vehicles like Innova Crysta, and Tempo Travellers suitable for families and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports anywhere in Mumbai so your Solapur journey begins smoothly."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for reliable intercity cab services. Our punctual drivers, comfortable vehicles, and professional service ensure a stress-free journey from Mumbai to Solapur."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Mumbai to Solapur?", answer: "Yes, Omshree Cabs provides reliable cab services from Mumbai to Solapur for both one-way and round-trip travel." },
  { question: "What is the distance from Mumbai to Solapur?", answer: "The distance from Mumbai to Solapur is approximately 400 km and the journey usually takes around 7 to 8 hours depending on traffic and road conditions." },
  { question: "Can I book a one-way cab from Mumbai to Solapur?", answer: "Yes, we offer both one-way and round-trip cab services for travel between Mumbai and Solapur." },
  { question: "Which vehicles are available for this route?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on group size." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our Mumbai to Solapur cab service operates 24/7 for passenger convenience." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can we stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals, rest, or refreshments." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially for long-distance travel routes." },
  { question: "Do you provide pickup from Mumbai Airport?", answer: "Yes, we provide pickup from Mumbai Airport for travelers heading to Solapur." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Shrikant Patil",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Solapur trip. The driver was professional and the vehicle was very comfortable for the long journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Kulkarni",
    feedback:
      "Excellent intercity cab service. Smooth travel from Mumbai to Solapur with a clean car and punctual driver.",
    rating: 5
  }
];










































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Solapur Cab",
  "description": "Omshree Cab offers reliable cab services from Mumbai to Solapur for one-way trips, round trips, and outstation travel. Choose from Innova, Ertiga, Sedan, and other well-maintained vehicles for a safe, comfortable, and punctual journey. Flexible booking options and transparent pricing ensure a hassle-free travel experience for family, corporate, and leisure trips.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "872"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Mumbai to Solapur Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab provides cab services from Mumbai to Solapur for one-way trips, round trips, and outstation travel. Travel with Innova, Ertiga, Sedan, and other vehicles. Safe, punctual, and comfortable journeys with flexible booking options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/69.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitosolapurcab;